
import Page404 from 'modules/spravochnik/dt-front-page-generator/views/_error/Page404.vue';

export default {
    components: {Page404},
    errorCaptured(err, vm, info) {

        const response = err.response;
        if (response && response.status == 404) {
            this.showError = true;
        } else if (err) {
            throw err;
        }
    },
    methods: {
        goBack() {
            return this.$router.go(-1);
        },
    },
    data() {
        return {
            showError: false,
        }
    },
}
